import { render, staticRenderFns } from "./TicoursesIndex.vue?vue&type=template&id=063129bc&scoped=true"
import script from "./TicoursesIndex.vue?vue&type=script&lang=js"
export * from "./TicoursesIndex.vue?vue&type=script&lang=js"
import style0 from "./TicoursesIndex.vue?vue&type=style&index=0&id=063129bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063129bc",
  null
  
)

export default component.exports